import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { SeoService } from 'src/app/services/seo.service';
@Component({
  selector: 'app-game-trivia',
  templateUrl: './game-trivia.component.html',
  styleUrls: ['./game-trivia.component.scss']
})
export class GameTriviaComponent implements OnInit {

  url: string;
  title: string;
  game: any;
  categories: any;
  roulette: any;
  cont: any;
  currentCat: number = 1;
  stage: number = 0;

  category: any;
  toolkit: any = false;
  private routeObs: Subscription;
  @ViewChild('appGameTutorial') appGameTutorial;
  public games = [
    {
      title: 'Incendios Forestales',
      img: '/assets/games/fuego-04.jpg',
      theme: 1,
      link: 'juego-inicio/incendios'
    },
    {
      title: 'Humedales',
      theme: 2,
      img: '/assets/games/fuego-01.jpg',
      link: 'juego-inicio/humedales'
    },
    {
      title: 'Criaturas amazónicas',
      theme: 3,
      img: '/assets/games/fuego-02.jpg',
      link: 'http://bufeo.wwfbolivia.org/'
    }
  ]

  constructor(private activatedRoute: ActivatedRoute,
    public seo: SeoService,
    public route: RoutingService,
    public api: RestapiService) {
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.loadArea();
      }, 10);
    });
  }

  ngOnInit(): void {
    this.loadArea();
  }

  loadArea() {
    this.url = this.activatedRoute.snapshot.paramMap.get('game');
    switch (this.url) {
      case 'incendios-forestales':
        this.game = this.games[0];
        this.title = 'Incendios Forestales';
        this.api.getdata('websection', {
          filters: {
            webroute_id: { value: 9 },
            webcontext_id: { value: 12 },
          }
        })
          .subscribe(res => {
            this.categories = [];
            this.categories.push(res.result.data[res.result.data.length - 1])
            res.result.data.forEach(element => {
              this.categories.push(element)
            });
            this.categories.push(res.result.data[0]);
            this.roulette = this.categories;
            console.log('secciones', this.categories);
          });
        this.seo.generateTags({
          title: 'WWF Educación Ambiental, Incendios Forestales Trivias',
          description: 'Incendios Forestales Trivias',
          image: '/assets/brand.png',
          slug: window.location.href,
        });
        break;
      case 'humedales':
        this.game = this.games[0];
        this.title = 'Humedales';
        this.api.getdata('websection', {
          filters: {
            webroute_id: { value: 9 },
            webcontext_id: { value: 13 },
          }
        })
          .subscribe(res => {
            this.categories = [];
            this.categories.push(res.result.data[res.result.data.length - 1])
            res.result.data.forEach(element => {
              this.categories.push(element)
            });
            this.categories.push(res.result.data[0]);
            this.roulette = this.categories;
            console.log('secciones', this.categories);
          });
          this.seo.generateTags({
            title: 'WWF Educación Ambiental, Humedales Trivias',
            description: 'Humedales Trivias',
            image: '/assets/brand.png',
            slug: window.location.href,
          });
        break;
    }
    /* this.url = this.activatedRoute.snapshot.paramMap.get('game');
    this.api.getdata('websection', { filters: { webroute_id: { value: 9 } } })
        .subscribe(res=>{
          this.categories = [];
          this.categories.push(res.result.data[res.result.data.length-1])
          res.result.data.forEach(element => {
            this.categories.push(element)
          });
          this.categories.push(res.result.data[0]);
          this.roulette = this.categories;
          console.log('secciones', this.categories);
        }) */
  }

  pickCategory(index) {
    this.currentCat = index;
    // this.switchStage('next');
    this.category = this.categories[index];
    this.route.goTo('trivia/' + this.url + '/' + this.category.id);
  }

  switchStage(target: any) {
    switch (target) {
      case 'next':
        (this.stage + 1 <= 4) ? this.stage++ : this.stage = 1;
        break;
      case 'prev':
        (this.stage - 1 >= 0) ? this.stage-- : '';
        break;
      default:
        this.stage = target;
    }
  }

  showToolkit() {
    this.toolkit = !this.toolkit;
  }

}
